// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Indonesia */
const ID = /^(?:8[1-35-9]\d{7,10})$/;

export default ID;
